'use strict'

const pullBlock = require('pull-block')

module.exports = (options) => {
  let maxSize = (typeof options === 'number') ? options : options.maxChunkSize
  return pullBlock(maxSize, { zeroPadding: false, emitEmpty: true })
}



//////////////////
// WEBPACK FOOTER
// ./~/ipfs-unixfs-engine/src/chunker/fixed-size.js
// module id = 493
// module chunks = 0